import { render, staticRenderFns } from "./ImportVehicleContracts.vue?vue&type=template&id=a8ba4b38"
import script from "./ImportVehicleContracts.vue?vue&type=script&lang=ts"
export * from "./ImportVehicleContracts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports